import { Controller } from '@hotwired/stimulus';
import events from 'lib/events';

// Handles dataLayer updates for use in Google Tag Manager
export default class GTMController extends Controller {
  connect() {
    this.removeGTMListeners();
    this.registerGTMListeners();
  }

  disconnect() {
    this.removeGTMListeners();
  }

  // These can be expanded to follow the GA controller pattern, but for now it's not needed.
  registerGTMListeners() {
    window.addEventListener(events.turbolinks.load, this.sendEvent, { once: false });
  }

  removeGTMListeners() {
    window.removeEventListener(events.turbolinks.load, this.sendEvent, { once: false });
  }

  // Send event names to dataLayer for use in GTM triggers
  sendEvent = (event) => {
    window.dataLayer.push({ event: event.type });
  }
}
